import { List } from 'antd';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { api } from '../../../config/Services';
import { DetailRequest } from '../../../utilities/services/RequestService';
import { Alert } from '../../../components';
import { Form } from 'antd';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partnercode: this.props.partnercode ? this.props.partnercode : null,
            dataList: [],
            isLoading: false
        }
    }

    componentDidMount() {
        this.cobrandDetail();
    }

    cobrandDetail = () => {
        let url = api.url.dashboard.detail;
        let data = { partnercode: this.state.partnercode };
        //call loader
        this.setState({ isLoading: true });
        DetailRequest(url, data).then((response) => {
            const { status, result } = response;
            const { responsecode, responsemessage } = response.status;
            if (responsecode === '0000' && result) {
                let dataList = result;

                this.setState({ dataList, isLoading: false });
            } else {
                Alert.error(responsemessage);
                this.setState({
                    responseCode: status.responsecode,
                    responseMessage: status.responsemessage,
                    formrender: false
                });
            }
        });
    }

    render() {
        const { dataList, isLoading } = this.state;

        return (
            <List loading={isLoading}
                rowKey={record => record.cobrand} dataSource={(dataList.cobrand) ? dataList.cobrand : []}
                grid={{ gutter: 16, column: 3 }}
                renderItem={item => (
                    <List.Item>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '12px', }}>{item.cobrandname}</div>
                            <div style={{ fontSize: '23px', fontWeight: '600', fontFamily: 'Segoe UI' }}>{Number(item.countmemberid).toLocaleString()}</div>
                        </div>
                    </List.Item>
                )}
            />
        )
    }
}

const mapStateToProps = state => ({ ...state });
export default connect(mapStateToProps)(Form.create()(App));